import React from 'react';
import { string } from 'prop-types';

import { makeLabelingTrackerUrl } from 'utils/url';

import './MissionCell.scss';

export default function MissionCell({ id, missionName }) {
  return (
    <div className="MissionCell">
      <p className="MissionCell__name" title={missionName}>
        {missionName}
      </p>
      <div>
        <a
          className="MissionCell__link"
          target="_blank"
          rel="noopener noreferrer"
          href={makeLabelingTrackerUrl(id)}
        >
          {id}
        </a>
      </div>
    </div>
  );
}

MissionCell.propTypes = {
  id: string.isRequired,
  missionName: string.isRequired,
};
